
import urlFile from "../common/ApiFile"
import url from "../common/api"
import axios from 'axios'

export async function addQueries(link,param,){

    const response= await axios.post(link,param,{ headers: { 'Content-Type': 'application/json','Accept': 'application/json' }})
    const data = await response;

        return data.data
  
}


